"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refresh = refresh;
exports.updateCompanies = updateCompanies;

var _immutable = require("immutable");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _Dispatch = require("crm_data/dispatch/Dispatch");

function refresh(ids) {
  return (0, _Dispatch.dispatchImmediate)(_ActionTypes.VISITS_REFRESH_QUEUED, (0, _immutable.Set)(ids));
}

function updateCompanies(companies) {
  (0, _invariant.default)(_immutable.Map.isMap(companies), 'VisitsActions: expected companies to be a Map but got "%s"');
  return (0, _Dispatch.dispatchImmediate)(_ActionTypes.VISITS_UPDATED, companies);
}